function isUndefined(e){return void 0===e}module.exports=isUndefined;